module.exports = __webpack_public_path__ + "img/send.898e15c9.svg";